import { Alert } from "@interstate/components/Alert";
import { SignatureApiErrorType } from "@coxauto-ui/cxm/communications/api";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface SignatureInsertErrorAlertProps {
  errorType: SignatureApiErrorType | null;
  onClose: () => void;
}

export function SignatureInsertErrorAlert({
  errorType,
  onClose
}: SignatureInsertErrorAlertProps) {
  if (!errorType) return null;

  const message =
    errorType === "not_found"
      ? ErrorMessages.SIGNATURE_NOT_FOUND
      : ErrorMessages.SIGNATURE_FETCH_ERROR;

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="signature-insert-error-alert"
        displayCloseButton={true}
        id="SignatureInsertErrorAlert"
        role="info"
        type="info"
        onCloseClick={onClose}
      >
        <span>{message}</span>
      </Alert>
    </StyledContainerAlert>
  );
}

export default SignatureInsertErrorAlert;
